import { OAuth2Client, OAuth2Fetch } from '@badgateway/oauth2-client';
import { ClientCredentialsRequest } from '@badgateway/oauth2-client/dist/messages';
import { Global } from '../../Global';
import { oauth2ClientCredentials } from '../config/clientCredentials';
import { getEnv } from './getEnv';

export const tokenStoreKey = 'token-store';

const client = () => new OAuth2Client(oauth2ClientCredentials[getEnv()]);

export const clearStoredToken = () =>
  window.localStorage.removeItem(tokenStoreKey);

export const getFetchWrapper = () =>
  new OAuth2Fetch({
    client: client(),

    getNewToken: async () => {
      if (process.env.NODE_ENV === 'development') {
        return client().password({
          username: Global['username'],
          password: Global['password'],
        });
      }
      return client().tokenResponseToOAuth2Token(
        client().request('tokenEndpoint', {
          grant_type: 'urn:ietf:params:oauth:grant-type:fsok_cookie',
        } as unknown as ClientCredentialsRequest)
        // Casting due to special GrantType that is not explicitly supported by the library.
      );
    },

    storeToken: (token) => {
      window.localStorage.setItem(tokenStoreKey, JSON.stringify(token));
    },

    getStoredToken: () => {
      const token = window.localStorage.getItem(tokenStoreKey);
      return token && JSON.parse(token);
    },
  });
